import React from 'react';
import type { FC } from 'react';
import { useNamedContainersWithChildren } from '@alfa-bank/site-named-container/utils';

import type { TIconView } from './models';

export const IconView: FC<TIconView> = ({
    Icon,
    backgroundColor,
    backgroundIcon,
    border,
    bottomAddons,
    children,
    className,
    dataTestId = 'icon-view',
    imageUrl,
    indicator,
    mainSize,
    size,
    topAddons,
}) => {
    const {
        bottomAddonsSlot,
        children: otherChildren,
        indicatorSlot,
        topAddonsSlot,
    } = useNamedContainersWithChildren(children);

    // Слоты bottomAddons, topAddons и indicator
    // - при разработке в АКИТ можно прокидывать, как пропсы
    // - при использовании в АССР слоты можно добавлять через NamedContainer
    return (
        <Icon
            backgroundColor={backgroundColor}
            backgroundIcon={backgroundIcon}
            border={border}
            bottomAddons={bottomAddons || bottomAddonsSlot}
            className={className}
            dataTestId={dataTestId}
            imageUrl={imageUrl}
            indicator={indicator || indicatorSlot}
            mainSize={mainSize}
            size={size}
            topAddons={topAddons || topAddonsSlot}
        >
            {otherChildren}
        </Icon>
    );
};
